// PCL
import priceFormatter from '../../formatters/price';
import { CARD_NO_REWARDS, CARD_REWARDS_MVP, CARD_TRIPLE_CASH_REWARDS, CARD_UNLIMITED_CASH_REWARDS, CARD_REWARDS_BITCOIN, CARD_REWARDS_ELITE, CARD_TRIPLE_CASH_REWARDS_ZERO, CARD_TRIPLE_CASH_REWARDS_FOCUS, CARD_REWARDS_ELITE_EARLY_PAY, CARD_REWARDS_BITCOIN_PLUS, CARD_LIFE_REWARDS, CARD_TRAVEL_CASH_REWARDS, LENDING_TREE_GROW, CARD_LIFE_REWARDS_FOCUS, CARD_CREDIT_BUILDER, ONE_CARD_CASH_REWARDS, ONE_CARD_CASH_REWARDS_SIMPLIFIED, GRADUATED_ONE_CARD, ONE_CARD_1_5_CASH_REWARDS, ONE_CARD_TRIPLE_CASH_REWARDS, ONE_CARD_UNLIMITED_CASH_REWARDS, SECURED_ONE_CARD, CARD_MYFIVE_CASH_REWARDS, CARD_CASH_REWARDS_WITH_AUTOPAY, CARD_REWARDS_MVP_WITH_ANNUAL_FEE, CARD_TRIPLE_CASH_REWARDS_WITH_ANNUAL_FEE, CARD_UNLIMITED_CASH_REWARDS_WITH_ANNUAL_FEE, CARD_REWARDS_ELITE_WITH_ANNUAL_FEE, CARD_REWARDS_ELITE_EARLY_PAY_WITH_ANNUAL_FEE, CARD_LIFE_REWARDS_WITH_ANNUAL_FEE, CARD_TRAVEL_CASH_BACK_REWARDS_SELECT, CARD_MYFIVE_CASH_REWARDS_WITH_ANNUAL_FEE, CARD_MYFIVE_CASH_REWARDS_V2_WITH_ANNUAL_FEE, CARD_CASH_REWARDS_WITH_AUTOPAY_WITH_ANNUAL_FEE, SECURED_ONE_CARD_WITH_UPSELL, SECURED_ONE_CARD_ZERO, CARD_MYFIVE_CASH_REWARDS_V2, ONE_CARD_SELECT, SECURED_ONE_CARD_WITH_CSA, SECURED_ONE_CARD_ZERO_WITH_CSA, SECURED_ONE_CARD_CREDIT_BUILDER, CARD_LIFE_REWARDS_NO_HEALTH, CARD_LIFE_REWARDS_NO_HEALTH_WITH_ANNUAL_FEE, CARD_LIFE_REWARDS_FOCUS_WITH_ANNUAL_FEE, CARD_TRIPLE_CASH_REWARDS_FOCUS_WITH_ANNUAL_FEE } from '../program-definition-code';
export const ONE_CARD_PROGRAM_DEFINITION_CODES = [ONE_CARD_CASH_REWARDS, ONE_CARD_1_5_CASH_REWARDS, ONE_CARD_TRIPLE_CASH_REWARDS, ONE_CARD_CASH_REWARDS_SIMPLIFIED, GRADUATED_ONE_CARD, ONE_CARD_UNLIMITED_CASH_REWARDS, SECURED_ONE_CARD, SECURED_ONE_CARD_WITH_UPSELL, SECURED_ONE_CARD_ZERO, ONE_CARD_SELECT, SECURED_ONE_CARD_WITH_CSA, SECURED_ONE_CARD_ZERO_WITH_CSA, SECURED_ONE_CARD_CREDIT_BUILDER];
export const SECURED_CARDS = [SECURED_ONE_CARD, SECURED_ONE_CARD_WITH_UPSELL, SECURED_ONE_CARD_ZERO, SECURED_ONE_CARD_WITH_CSA, SECURED_ONE_CARD_ZERO_WITH_CSA, SECURED_ONE_CARD_CREDIT_BUILDER];
export const CREDIT_BUILDER_CARDS = [SECURED_ONE_CARD_CREDIT_BUILDER];
export const MUTABLE_SECURED_CARDS = [SECURED_ONE_CARD_WITH_UPSELL];
export const REWARDS_MVP_CARDS = [CARD_REWARDS_MVP, CARD_REWARDS_MVP_WITH_ANNUAL_FEE];
export const TRIPLE_CASH_REWARDS_FOCUS_CARDS = [CARD_TRIPLE_CASH_REWARDS_ZERO, CARD_TRIPLE_CASH_REWARDS_FOCUS, CARD_TRIPLE_CASH_REWARDS_FOCUS_WITH_ANNUAL_FEE];
export const TRIPLE_CASH_REWARDS_CARDS = [...TRIPLE_CASH_REWARDS_FOCUS_CARDS, CARD_TRIPLE_CASH_REWARDS, CARD_TRIPLE_CASH_REWARDS_WITH_ANNUAL_FEE];
export const UNLIMITED_CASH_REWARDS_CARDS = [CARD_UNLIMITED_CASH_REWARDS, CARD_UNLIMITED_CASH_REWARDS_WITH_ANNUAL_FEE];
export const REWARDS_ELITE_CARDS = [CARD_REWARDS_ELITE, CARD_REWARDS_ELITE_WITH_ANNUAL_FEE, CARD_REWARDS_ELITE_EARLY_PAY, CARD_REWARDS_ELITE_EARLY_PAY_WITH_ANNUAL_FEE];
export const LIFE_REWARDS_CARDS = [CARD_LIFE_REWARDS, CARD_LIFE_REWARDS_WITH_ANNUAL_FEE];
export const LIFE_REWARDS_FOCUS_CARDS = [CARD_LIFE_REWARDS_FOCUS, CARD_LIFE_REWARDS_FOCUS_WITH_ANNUAL_FEE];
export const LIFE_REWARDS_NO_HEALTH_CARDS = [...LIFE_REWARDS_FOCUS_CARDS, CARD_LIFE_REWARDS_NO_HEALTH, CARD_LIFE_REWARDS_NO_HEALTH_WITH_ANNUAL_FEE];
export const TRAVEL_CASH_REWARDS_CARDS = [CARD_TRAVEL_CASH_REWARDS, CARD_TRAVEL_CASH_BACK_REWARDS_SELECT];
export const MYFIVE_CASH_REWARDS_V1_CARDS = [CARD_MYFIVE_CASH_REWARDS, CARD_MYFIVE_CASH_REWARDS_WITH_ANNUAL_FEE];
export const MYFIVE_CASH_REWARDS_V2_CARDS = [CARD_MYFIVE_CASH_REWARDS_V2, CARD_MYFIVE_CASH_REWARDS_V2_WITH_ANNUAL_FEE];
export const MYFIVE_CASH_REWARDS_CARDS = [...MYFIVE_CASH_REWARDS_V1_CARDS, ...MYFIVE_CASH_REWARDS_V2_CARDS];
export const CASH_REWARDS_WITH_AUTOPAY_CARDS = [CARD_CASH_REWARDS_WITH_AUTOPAY, CARD_CASH_REWARDS_WITH_AUTOPAY_WITH_ANNUAL_FEE];

// deprecated in favor of SELECT_CARD_VARIANTS
export const EXPANDED_COUNTER_OFFER_WITH_ANNUAL_FEE_PROGRAM_DEFINTION_CODES = [CARD_REWARDS_MVP_WITH_ANNUAL_FEE, CARD_TRIPLE_CASH_REWARDS_WITH_ANNUAL_FEE, CARD_UNLIMITED_CASH_REWARDS_WITH_ANNUAL_FEE, CARD_REWARDS_ELITE_WITH_ANNUAL_FEE, CARD_REWARDS_ELITE_EARLY_PAY_WITH_ANNUAL_FEE, CARD_LIFE_REWARDS_WITH_ANNUAL_FEE, CARD_TRAVEL_CASH_BACK_REWARDS_SELECT, CARD_MYFIVE_CASH_REWARDS_WITH_ANNUAL_FEE, CARD_MYFIVE_CASH_REWARDS_V2_WITH_ANNUAL_FEE, CARD_CASH_REWARDS_WITH_AUTOPAY_WITH_ANNUAL_FEE, ONE_CARD_SELECT];
export const SELECT_CARD_VARIANTS = [CARD_REWARDS_MVP_WITH_ANNUAL_FEE, CARD_TRIPLE_CASH_REWARDS_WITH_ANNUAL_FEE, CARD_TRIPLE_CASH_REWARDS_FOCUS_WITH_ANNUAL_FEE, CARD_UNLIMITED_CASH_REWARDS_WITH_ANNUAL_FEE, CARD_REWARDS_ELITE_WITH_ANNUAL_FEE, CARD_REWARDS_ELITE_EARLY_PAY_WITH_ANNUAL_FEE, CARD_LIFE_REWARDS_WITH_ANNUAL_FEE, CARD_LIFE_REWARDS_NO_HEALTH_WITH_ANNUAL_FEE, CARD_LIFE_REWARDS_FOCUS_WITH_ANNUAL_FEE, CARD_TRAVEL_CASH_BACK_REWARDS_SELECT, CARD_MYFIVE_CASH_REWARDS_WITH_ANNUAL_FEE, CARD_MYFIVE_CASH_REWARDS_V2_WITH_ANNUAL_FEE, CARD_CASH_REWARDS_WITH_AUTOPAY_WITH_ANNUAL_FEE, ONE_CARD_SELECT];
export const CARDS_WITH_ANNUAL_FEE = [...SELECT_CARD_VARIANTS, CARD_CREDIT_BUILDER];
const withIntroductoryRewards = (programDefinitionCode, introCode) => `${programDefinitionCode}_I${introCode}`;
export const ACTIVE_PROGRAM_DEFINITION_CODES = [CARD_REWARDS_MVP, withIntroductoryRewards(CARD_REWARDS_MVP, '01'), withIntroductoryRewards(CARD_REWARDS_MVP, '02'), CARD_TRIPLE_CASH_REWARDS, CARD_TRIPLE_CASH_REWARDS_ZERO, CARD_TRIPLE_CASH_REWARDS_FOCUS, CARD_UNLIMITED_CASH_REWARDS, CARD_REWARDS_ELITE, withIntroductoryRewards(CARD_REWARDS_ELITE, '01'), CARD_REWARDS_ELITE_EARLY_PAY, CARD_LIFE_REWARDS, CARD_LIFE_REWARDS_FOCUS, CARD_LIFE_REWARDS_NO_HEALTH, CARD_TRAVEL_CASH_REWARDS, ONE_CARD_CASH_REWARDS, ONE_CARD_1_5_CASH_REWARDS, ONE_CARD_TRIPLE_CASH_REWARDS, ONE_CARD_CASH_REWARDS_SIMPLIFIED, ONE_CARD_UNLIMITED_CASH_REWARDS, SECURED_ONE_CARD, SECURED_ONE_CARD_WITH_UPSELL, SECURED_ONE_CARD_ZERO, SECURED_ONE_CARD_ZERO_WITH_CSA, SECURED_ONE_CARD_WITH_CSA, SECURED_ONE_CARD_CREDIT_BUILDER, CARD_MYFIVE_CASH_REWARDS, CARD_MYFIVE_CASH_REWARDS_V2, CARD_CASH_REWARDS_WITH_AUTOPAY, ...SELECT_CARD_VARIANTS];
export const ALL_PROGRAM_DEFINITION_CODES = [...ACTIVE_PROGRAM_DEFINITION_CODES, CARD_NO_REWARDS, CARD_CREDIT_BUILDER];
export const ELITE_PROGRAM_DEFINITION_CODES = [CARD_REWARDS_ELITE, CARD_REWARDS_ELITE_EARLY_PAY];
export const FIXED_PERCENTAGE_PROGRAM_DEFINITION_CODES = [CARD_REWARDS_MVP, CARD_REWARDS_MVP_WITH_ANNUAL_FEE, ONE_CARD_1_5_CASH_REWARDS, ONE_CARD_UNLIMITED_CASH_REWARDS, CARD_UNLIMITED_CASH_REWARDS, CARD_UNLIMITED_CASH_REWARDS_WITH_ANNUAL_FEE, CARD_REWARDS_ELITE, CARD_REWARDS_ELITE_WITH_ANNUAL_FEE, CARD_REWARDS_ELITE_EARLY_PAY, CARD_REWARDS_ELITE_EARLY_PAY_WITH_ANNUAL_FEE];
export const WELCOME_BONUS_PROGRAM_DEFINITION_CODES = [CARD_NO_REWARDS, CARD_REWARDS_MVP, CARD_TRIPLE_CASH_REWARDS, CARD_UNLIMITED_CASH_REWARDS, CARD_TRIPLE_CASH_REWARDS_ZERO, CARD_TRIPLE_CASH_REWARDS_FOCUS, CARD_REWARDS_ELITE, CARD_REWARDS_ELITE_EARLY_PAY, CARD_REWARDS_BITCOIN, CARD_REWARDS_BITCOIN_PLUS, CARD_LIFE_REWARDS, CARD_LIFE_REWARDS_FOCUS, CARD_LIFE_REWARDS_NO_HEALTH, CARD_TRAVEL_CASH_REWARDS, ONE_CARD_CASH_REWARDS, ONE_CARD_1_5_CASH_REWARDS, ONE_CARD_TRIPLE_CASH_REWARDS, ONE_CARD_CASH_REWARDS_SIMPLIFIED, ONE_CARD_UNLIMITED_CASH_REWARDS, SECURED_ONE_CARD, SECURED_ONE_CARD_WITH_CSA, SECURED_ONE_CARD_CREDIT_BUILDER, CARD_MYFIVE_CASH_REWARDS, CARD_MYFIVE_CASH_REWARDS_V2, CARD_CASH_REWARDS_WITH_AUTOPAY, CARD_CREDIT_BUILDER];
export const REWARDS_CHECKING_BONUS_PROGRAM_DEFINITION_CODES = [CARD_NO_REWARDS, CARD_REWARDS_MVP, CARD_TRIPLE_CASH_REWARDS, CARD_UNLIMITED_CASH_REWARDS, CARD_TRIPLE_CASH_REWARDS_ZERO, CARD_TRIPLE_CASH_REWARDS_FOCUS, CARD_REWARDS_ELITE, CARD_REWARDS_ELITE_EARLY_PAY, CARD_REWARDS_BITCOIN, CARD_REWARDS_BITCOIN_PLUS, CARD_LIFE_REWARDS, CARD_LIFE_REWARDS_FOCUS, CARD_LIFE_REWARDS_NO_HEALTH, CARD_TRAVEL_CASH_REWARDS, CARD_CREDIT_BUILDER, ONE_CARD_CASH_REWARDS, ONE_CARD_1_5_CASH_REWARDS, ONE_CARD_TRIPLE_CASH_REWARDS, ONE_CARD_CASH_REWARDS_SIMPLIFIED, ONE_CARD_UNLIMITED_CASH_REWARDS, SECURED_ONE_CARD, SECURED_ONE_CARD_WITH_CSA, SECURED_ONE_CARD_CREDIT_BUILDER, CARD_MYFIVE_CASH_REWARDS, CARD_MYFIVE_CASH_REWARDS_V2, CARD_CASH_REWARDS_WITH_AUTOPAY, ...SELECT_CARD_VARIANTS];
export const EARLY_PAY_PROGRAM_DEFINITION_CODES = [CARD_REWARDS_ELITE_EARLY_PAY, CARD_REWARDS_ELITE_EARLY_PAY_WITH_ANNUAL_FEE, CARD_LIFE_REWARDS, CARD_LIFE_REWARDS_WITH_ANNUAL_FEE, CARD_LIFE_REWARDS_FOCUS, CARD_LIFE_REWARDS_FOCUS_WITH_ANNUAL_FEE, CARD_LIFE_REWARDS_NO_HEALTH, CARD_LIFE_REWARDS_NO_HEALTH_WITH_ANNUAL_FEE, CARD_TRAVEL_CASH_REWARDS, CARD_MYFIVE_CASH_REWARDS, CARD_MYFIVE_CASH_REWARDS_V2];
export const PROGRAM_DEFINITION_CODE_REWARD_PERCENTAGE = {
  [CARD_REWARDS_MVP]: {
    base: {
      value: '1.5%',
      intro: {
        I01: '3%',
        I02: '4%'
      }
    },
    E01: {
      value: '2%'
    }
  },
  [CARD_REWARDS_MVP_WITH_ANNUAL_FEE]: {
    base: {
      value: '1.5%',
      intro: {
        I01: '3%',
        I02: '4%'
      }
    },
    E01: {
      value: '2%'
    }
  },
  [CARD_UNLIMITED_CASH_REWARDS]: {
    base: {
      value: '1%'
    },
    E01: {
      value: '1.5%'
    }
  },
  [CARD_UNLIMITED_CASH_REWARDS_WITH_ANNUAL_FEE]: {
    base: {
      value: '1%'
    },
    E01: {
      value: '1.5%'
    }
  },
  [CARD_REWARDS_ELITE]: {
    base: {
      value: '2.2%',
      intro: {
        I01: '4%'
      }
    },
    E01: {
      value: '2.5%'
    }
  },
  [CARD_REWARDS_ELITE_WITH_ANNUAL_FEE]: {
    base: {
      value: '2.2%',
      intro: {
        I01: '4%'
      }
    },
    E01: {
      value: '2.5%'
    }
  },
  [CARD_REWARDS_ELITE_EARLY_PAY]: {
    base: {
      value: '2.2%'
    }
  },
  [CARD_REWARDS_ELITE_EARLY_PAY_WITH_ANNUAL_FEE]: {
    base: {
      value: '2.2%'
    }
  },
  [CARD_REWARDS_BITCOIN]: {
    base: {
      value: '1.5%'
    },
    E01: {
      value: '2%'
    }
  },
  [CARD_REWARDS_BITCOIN_PLUS]: {
    base: {
      value: '2%'
    }
  },
  [CARD_TRIPLE_CASH_REWARDS_ZERO]: {
    base: {
      value: '3%'
    }
  },
  [CARD_TRIPLE_CASH_REWARDS_FOCUS]: {
    base: {
      value: '3%'
    }
  },
  [CARD_TRIPLE_CASH_REWARDS]: {
    base: {
      value: '3%'
    },
    E01: {
      value: '4%'
    }
  },
  [CARD_TRIPLE_CASH_REWARDS_WITH_ANNUAL_FEE]: {
    base: {
      value: '3%'
    },
    E01: {
      value: '4%'
    }
  },
  [ONE_CARD_PROGRAM_DEFINITION_CODES]: {
    base: {
      value: '3%'
    }
  },
  [ONE_CARD_1_5_CASH_REWARDS]: {
    base: {
      value: '1.5%'
    }
  },
  [ONE_CARD_UNLIMITED_CASH_REWARDS]: {
    base: {
      value: '1%'
    },
    E01: {
      value: '1.5%'
    }
  }
};
export const BITCOIN_PROGRAM_DEFINITION_CODES = [CARD_REWARDS_BITCOIN, CARD_REWARDS_BITCOIN_PLUS];
export const LENDING_TREE_PROGRAM_DEFINITION_CODES = [LENDING_TREE_GROW];
export const isSecuredCard = code => SECURED_CARDS.includes(code);
export const isMutableSecuredCard = code => MUTABLE_SECURED_CARDS.includes(code);
export const isAnnualFeeCard = code => CARDS_WITH_ANNUAL_FEE.includes(code);
export const getIntroPercentage = ({
  code,
  introCode,
  enhancementCode
}) => {
  if (!code) return null;
  const percentages = PROGRAM_DEFINITION_CODE_REWARD_PERCENTAGE[code];
  if (!percentages) return null;
  const {
    intro
  } = percentages[enhancementCode] || percentages.base;
  if (!intro) return null;
  return intro[introCode];
};
export const getEffectivePercentage = ({
  code,
  enhancementCode
}) => {
  if (!code) return null;
  const percentages = PROGRAM_DEFINITION_CODE_REWARD_PERCENTAGE[code];
  if (!percentages) return null;
  return (percentages[enhancementCode] || percentages.base).value;
};
export const getBasePercentage = ({
  code
}) => getEffectivePercentage({
  code
});
const INTRO_CODE_REGEX = /I\d+/;
const ENHANCED_CODE_REGEX = /E\d+/;
const EXTENSIONS_REGEXES = [INTRO_CODE_REGEX, ENHANCED_CODE_REGEX];
export const deconstructProgramDefinitionCode = code => {
  if (!code) return null;
  const firstExtensionIndex = EXTENSIONS_REGEXES.reduce((agg, re) => {
    const index = code.search(re);
    if (agg === -1) {
      return index;
    }
    return index === -1 ? agg : Math.min(agg, index);
  }, -1);
  if (firstExtensionIndex === -1) {
    return {
      base: code
    };
  }
  const base = code.slice(0, firstExtensionIndex - 1);
  const extensions = code.slice(firstExtensionIndex).split('_');
  return {
    base,
    ...extensions.reduce((agg, extension) => {
      if (INTRO_CODE_REGEX.test(extension)) return {
        ...agg,
        intro: extension
      };
      if (ENHANCED_CODE_REGEX.test(extension)) return {
        ...agg,
        enhancement: extension
      };
      return agg;
    }, {})
  };
};
export const buildProgramDefinitionCode = ({
  base,
  enhancement,
  intro
}) => {
  if (!base) return null;
  return [base, enhancement, intro].filter(Boolean).join('_');
};
export const extractBaseProgramDefinitionCode = code => deconstructProgramDefinitionCode(code)?.base;
export const extractProgramDefinitionIntroCode = code => deconstructProgramDefinitionCode(code)?.intro;
const PROGRAM_DEFINITION_CODE_ANNUAL_FEE = {
  [CARD_CREDIT_BUILDER]: 39,
  [CARD_REWARDS_MVP_WITH_ANNUAL_FEE]: 48,
  [CARD_TRIPLE_CASH_REWARDS_WITH_ANNUAL_FEE]: 48,
  [CARD_TRIPLE_CASH_REWARDS_FOCUS_WITH_ANNUAL_FEE]: 48,
  [CARD_UNLIMITED_CASH_REWARDS_WITH_ANNUAL_FEE]: 48,
  [CARD_REWARDS_ELITE_WITH_ANNUAL_FEE]: 48,
  [CARD_REWARDS_ELITE_EARLY_PAY_WITH_ANNUAL_FEE]: 48,
  [CARD_LIFE_REWARDS_WITH_ANNUAL_FEE]: 48,
  [CARD_LIFE_REWARDS_FOCUS_WITH_ANNUAL_FEE]: 48,
  [CARD_LIFE_REWARDS_NO_HEALTH_WITH_ANNUAL_FEE]: 48,
  [CARD_TRAVEL_CASH_BACK_REWARDS_SELECT]: 48,
  [CARD_MYFIVE_CASH_REWARDS_WITH_ANNUAL_FEE]: 48,
  [CARD_MYFIVE_CASH_REWARDS_V2_WITH_ANNUAL_FEE]: 48,
  [CARD_CASH_REWARDS_WITH_AUTOPAY_WITH_ANNUAL_FEE]: 48,
  [ONE_CARD_SELECT]: 48
};
const getProgramDefinitionCodeAnnualFee = programDefinitionCode => PROGRAM_DEFINITION_CODE_ANNUAL_FEE[programDefinitionCode] || 0;
export const formatProgramDefinitionCodeAnnualFee = programDefinitionCode => priceFormatter(getProgramDefinitionCodeAnnualFee(programDefinitionCode), {
  smart: true
});
//# sourceMappingURL=program-definition-code.js.map